<h1>Angular UI Scroll Settings Demos</h1>

<p>
  <em>Settings</em> object is&nbsp;a&nbsp;part of&nbsp;<em>Datasource</em>
  implementation. It allows us to configure the&nbsp;Scroller during its
  initialization. Each sample on this page deals with a&nbsp;single setting and
  includes:
</p>

<ul>
  <li>working viewport with scrollable area;</li>
  <li>
    log section where we&nbsp;may see current size of&nbsp;the viewport, how
    many real items (DOM elements) the viewport has in&nbsp;the&nbsp;moment and
    how many items have been retrieved via Datasource.get;
  </li>
  <li>
    code listing which contains Datasource typescript code, Template html code
    and CSS;
  </li>
  <li>description and explanations.</li>
</ul>

<app-demo-basic></app-demo-basic>
<app-demo-buffer-size></app-demo-buffer-size>
<app-demo-padding></app-demo-padding>
<app-demo-item-size></app-demo-item-size>
<app-demo-start-index></app-demo-start-index>
<app-demo-min-max-indexes></app-demo-min-max-indexes>
<app-demo-infinite></app-demo-infinite>
<app-demo-horizontal></app-demo-horizontal>
<app-demo-different-heights></app-demo-different-heights>
<app-demo-window-viewport></app-demo-window-viewport>
